<template>
  <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M11.5908 16C13.2477 16 14.5908 14.6569 14.5908 13C14.5908 11.3431 13.2477 10 11.5908 10C9.93397 10 8.59082 11.3431 8.59082 13C8.59082 14.6569 9.93397 16 11.5908 16Z"
      class="fill-current"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M5.69291 5.57377C5.37396 5.57377 5.11541 5.84066 5.11541 6.1699V33.8301C5.11541 34.1593 5.37396 34.4262 5.69291 34.4262H33.4887C33.8077 34.4262 34.0662 34.1593 34.0662 33.8301V6.1699C34.0662 5.84066 33.8077 5.57377 33.4887 5.57377H5.69291ZM3.59082 6.1699C3.59082 4.9715 4.53196 4 5.69291 4H33.4887C34.6497 4 35.5908 4.9715 35.5908 6.1699V33.8301C35.5908 35.0285 34.6497 36 33.4887 36H5.69291C4.53196 36 3.59082 35.0285 3.59082 33.8301V6.1699Z"
      class="fill-current"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M27.2273 16.5366C27.1546 16.5366 27.0819 16.551 27.013 16.5798C26.944 16.6087 26.8793 16.6519 26.8234 16.7084L7.95171 35.7644C7.64888 36.0701 7.1482 36.0796 6.8334 35.7854C6.51861 35.4912 6.50892 35.0048 6.81175 34.6991L25.6829 15.6436C25.8827 15.4418 26.1219 15.2797 26.387 15.1687C26.6524 15.0576 26.938 15 27.2273 15C27.5165 15 27.8021 15.0576 28.0675 15.1687C28.3327 15.2797 28.5716 15.4415 28.7714 15.6434L35.3699 22.3075C35.6727 22.6133 35.663 23.0997 35.3482 23.3938C35.0334 23.688 34.5327 23.6785 34.2299 23.3727L27.6313 16.7086C27.5755 16.6521 27.5105 16.6087 27.4415 16.5798C27.3726 16.551 27.2999 16.5366 27.2273 16.5366Z"
      class="fill-current"
    />
  </svg>
</template>
